import { r, h as t, H as i } from "./main-bb89b2f2.js";
import "vue";
const o = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}div *{color:var(--color-neutral-steel-800)}div:hover *{color:var(--color-neutral-steel-600)}div:active *{color:var(--color-black)}div.dark *{color:var(--color-white)}div.dark:hover *{color:var(--color-neutral-steel-400)}div.dark:active *{color:var(--color-neutral-steel-100)}.static{position:static}.flex{display:flex}.cursor-pointer{cursor:pointer}.text-center{text-align:center}.block{display:block}", a = o, l = class {
  constructor(e) {
    r(this, e), this.allowedTypes = [
      "arrow-down",
      "arrow-up",
      "arrow-right",
      "arrow-left",
      "plus",
      "minus",
      "x",
      "play",
      "stop",
      "pause"
    ], this.disabled = !1, this.size = "32px", this.variant = "light", this.type = "x";
  }
  render() {
    if (this.allowedTypes.indexOf(this.type) < 0)
      throw new Error('Invalid <patternlib-control-element> type "' + this.type + '". Type can only be arrow-down, arrow-up, arrow-right, arrow-left, plus, minus, x, play, stop, pause');
    const e = {
      "flex text-center": !0,
      dark: this.variant === "dark",
      "cursor-pointer": !this.disabled
    };
    return t(i, { key: "3a0aa1cdb7ed84dd1d43363e1a77c375544ee213" }, this.allowedTypes.indexOf(this.type) >= 0 && t("div", { key: "bea49af862359645f11adfdfafdc61ab206caa53", class: e }, t("patternlib-icon", { key: "619b82c5722596c0f4ebee4da9ee5f6d02309490", size: this.size, disabled: this.disabled, iconName: this.type, tabindex: "0", bold: !0 })));
  }
};
l.style = a;
export {
  l as patternlib_control_element
};
